var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 764.61 507.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 367.85,
    y1: 510.79,
    x2: 367.85,
    y2: -74.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbecf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3f7ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 138.36,
    y1: 512.61,
    x2: 138.36,
    y2: -73.14,
    gradientTransform: "translate(68.23 -86.36) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 749.6,
    y1: 512.61,
    x2: 749.6,
    y2: -73.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 547.23,
    y1: 508.7,
    x2: 547.23,
    y2: -11.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 396.33,
    y1: 440.51,
    x2: 390.97,
    y2: 275.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abdff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e9f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 409.17,
    y1: 415.22,
    x2: 436.73,
    y2: 415.22,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 334.23,
    y1: 59.92,
    x2: 358.88,
    y2: 94.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49d3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07b9fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 326.08,
    y1: 67.25,
    x2: 348.67,
    y2: 99.12,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 602.54,
    y1: 199.41,
    x2: 614.86,
    y2: 216.8,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 598.47,
    y1: 203.08,
    x2: 609.76,
    y2: 219.01,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 74.61,
    y1: 315.43,
    x2: 46.13,
    y2: 270.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 68.77,
    y1: 319.13,
    x2: 40.29,
    y2: 274.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 528,
    y1: 506.57,
    x2: 528,
    y2: 252.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0069bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44a4fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 427.69,
    y1: 468.06,
    x2: 466.17,
    y2: 507,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 438.49,
    y1: 457.09,
    x2: 476.98,
    y2: 496.03,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 628.45,
    y1: 480.21,
    x2: 470.38,
    y2: 480.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5e0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4d2ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 628.45,
    y1: 480.18,
    x2: 470.38,
    y2: 480.18,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 637.94,
    y1: 472.89,
    x2: 637.94,
    y2: 487.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 506.57,
    y2: 252.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 452.91,
    y1: 451.79,
    x2: 425.77,
    y2: 412.43,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 583.48,
    y1: 422.47,
    x2: 583.48,
    y2: 439.64,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 637.94,
    y1: 425.29,
    x2: 637.94,
    y2: 439.54,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 506.57,
    y2: 252.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 429.54,
    y1: 384.99,
    x2: 483.11,
    y2: 384.99,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 452.8,
    y1: 384.99,
    x2: 469.82,
    y2: 384.99,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 583.48,
    y1: 374.88,
    x2: 583.48,
    y2: 392.04,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 617.5,
    y1: 399.74,
    x2: 577.73,
    y2: 366.23,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 637.94,
    y1: 377.7,
    x2: 637.94,
    y2: 391.95,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 506.57,
    y2: 252.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 429.54,
    y1: 337.4,
    x2: 483.11,
    y2: 337.4,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 615.87,
    y1: 356.08,
    x2: 568.51,
    y2: 328.82,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 619.99,
    y1: 348.92,
    x2: 572.63,
    y2: 321.66,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 637.94,
    y1: 330.11,
    x2: 637.94,
    y2: 344.36,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 528,
    y1: 506.58,
    x2: 528,
    y2: 252.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 600.04,
    y1: 279.69,
    x2: 600.04,
    y2: 296.85,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 637.94,
    y1: 282.51,
    x2: 637.94,
    y2: 296.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 450.88,
    y1: 349.56,
    x2: 452.03,
    y2: 375.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 417.61,
    y1: 306.2,
    x2: 417.61,
    y2: 338.67,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 419.8,
    y1: 298.51,
    x2: 419.8,
    y2: 313.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#facdae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb895"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 446.38,
    y1: 234.01,
    x2: 446.38,
    y2: 240.73,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 432.17,
    y1: 239.93,
    x2: 432.17,
    y2: 335.28,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 444.43,
    y1: 259.32,
    x2: 444.43,
    y2: 274.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15175e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 454.7,
    y1: 345.52,
    x2: 455.16,
    y2: 355.84,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 466.23,
    y1: 241.17,
    x2: 466.23,
    y2: 339.06,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 444.44,
    y1: 177.61,
    x2: 444.44,
    y2: 248.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#038cfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 450.01,
    y1: 198.91,
    x2: 450.01,
    y2: 209.94,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 471.8,
    y1: 177.61,
    x2: 471.8,
    y2: 248.23,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 395.83,
    y1: 159.05,
    x2: 388.93,
    y2: 189.94,
    gradientTransform: "translate(78.34)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 54.87,
    y1: 167.91,
    x2: 67.99,
    y2: 177.35,
    gradientTransform: "translate(526.36) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 386.86,
    y1: 157,
    x2: 379.95,
    y2: 187.97,
    gradientTransform: "translate(78.34)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 394.87,
    y1: 158.83,
    x2: 387.97,
    y2: 189.72,
    gradientTransform: "translate(78.34)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 486.89,
    y1: 194.17,
    x2: 486.89,
    y2: 237.43,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 393.36,
    y1: 181.83,
    x2: 468.58,
    y2: 217.26,
    gradientTransform: "translate(-16.7 30.89) rotate(-4.51)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 432.99,
    y1: 193.92,
    x2: 432.99,
    y2: 243.78,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 413.33,
    y1: 234.55,
    x2: 421.04,
    y2: 238.19,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 98.46,
    y1: 228.71,
    x2: 94.48,
    y2: 242.27,
    gradientTransform: "translate(526.36) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 491.51,
    y1: 177.61,
    x2: 491.51,
    y2: 248.23,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 314.73,
    y1: 286.08,
    x2: 314.73,
    y2: 382.8,
    gradientTransform: "translate(629.47 828.02) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ebcf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85c2eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 311.87,
    y1: 337.91,
    x2: 311.87,
    y2: 482.85,
    gradientTransform: "translate(623.74 828.02) rotate(-180)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 287.84,
    y1: 345.34,
    x2: 343.8,
    y2: 365.45,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 319.73,
    y1: 348.07,
    x2: 319.73,
    y2: 266.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 41.44,
    y1: 347.93,
    x2: 41.44,
    y2: 253.93,
    gradientTransform: "translate(358.74) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 294.25,
    y1: 270.99,
    x2: 332.62,
    y2: 302.16,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 335.65,
    y1: 314.2,
    x2: 357.42,
    y2: 314.2,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 299.2,
    y1: 323.05,
    x2: 344.03,
    y2: 323.05,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 340.9,
    y1: 273.31,
    x2: 362.68,
    y2: 273.31,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 223.48,
    y1: 301.28,
    x2: 245.38,
    y2: 314.27,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 222.2,
    y1: 303.43,
    x2: 244.11,
    y2: 316.42,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 220.93,
    y1: 305.58,
    x2: 242.83,
    y2: 318.57,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 218.69,
    y1: 309.34,
    x2: 240.6,
    y2: 322.33,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 182.69,
    y1: 279.46,
    x2: 204.14,
    y2: 294.12,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 180.77,
    y1: 282.28,
    x2: 202.21,
    y2: 296.94,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 178.84,
    y1: 285.09,
    x2: 200.29,
    y2: 299.76,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 175.27,
    y1: 290.32,
    x2: 196.71,
    y2: 304.98,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 192.6,
    y1: 223.68,
    x2: 214.72,
    y2: 238.65,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 191.29,
    y1: 225.62,
    x2: 213.41,
    y2: 240.59,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 188.87,
    y1: 229.2,
    x2: 210.99,
    y2: 244.17,
    gradientTransform: "translate(630.29) rotate(-180) scale(1 -1) skewX(17.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 267.93,
    y1: 490.52,
    x2: 282,
    y2: 490.52,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 267.35,
    y1: 501.39,
    x2: 297.73,
    y2: 501.39,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 199.94,
    y1: 486.5,
    x2: 215.97,
    y2: 486.5,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 194.45,
    y1: 495.73,
    x2: 221.99,
    y2: 495.73,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 244.62,
    y1: 492.24,
    x2: 244.62,
    y2: 344.21,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 271.41,
    y1: 228.89,
    x2: 271.76,
    y2: 255.42,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 228.23,
    y1: 303.5,
    x2: 243.61,
    y2: 303.5,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 236.18,
    y1: 253,
    x2: 236.18,
    y2: 336.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16a4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 238.26,
    y1: 277.33,
    x2: 238.26,
    y2: 317.16,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 253.91,
    y1: 253.04,
    x2: 253.91,
    y2: 335.71,
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 273.01,
    y1: 272.19,
    x2: 273.01,
    y2: 346.51,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 324.42,
    y1: 279.29,
    x2: 324.16,
    y2: 282.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#facdae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcac8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 272.68,
    y1: 298.82,
    x2: 333.88,
    y2: 298.82,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 278.19,
    y1: 253.27,
    x2: 278.19,
    y2: 335.23,
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 274.32,
    y1: 228.87,
    x2: 274.66,
    y2: 255.46,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 251.35,
    y1: 392.72,
    x2: 255.3,
    y2: 392.72,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 73.58,
    y1: 491.2,
    x2: 86.58,
    y2: 491.2,
    gradientTransform: "translate(198.53) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 108.09,
    y1: 489.59,
    x2: 121.8,
    y2: 489.59,
    gradientTransform: "translate(236.34 11.43) rotate(-174.88) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 61.01,
    y1: 501.86,
    x2: 88.59,
    y2: 501.86,
    gradientTransform: "translate(198.53) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 35.76,
    y1: 238.05,
    x2: 32.88,
    y2: 303.27,
    gradientTransform: "translate(242.05 11.64) rotate(-170.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 48.22,
    y1: 258.15,
    x2: 48.22,
    y2: 333.78,
    gradientTransform: "translate(242.05 11.64) rotate(-170.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 151.02,
    y1: 276.73,
    x2: 151.02,
    y2: 292.61,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 112.02,
    y1: 486.47,
    x2: 112.02,
    y2: 288.47,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 61.31,
    y1: 500.8,
    x2: 83.52,
    y2: 500.8,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 120.85,
    y1: 256.52,
    x2: 120.85,
    y2: 331.25,
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 99.23,
    y1: 286.3,
    x2: 99.23,
    y2: 326.3,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 68.38,
    y1: 221.28,
    x2: 80.6,
    y2: 256.08,
    gradientTransform: "translate(198.53) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 72.39,
    y1: 246.67,
    x2: 82.08,
    y2: 246.67,
    gradientTransform: "translate(198.53) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 59.79,
    y1: 201.1,
    x2: 72,
    y2: 235.9,
    gradientTransform: "translate(155.28 12.37) rotate(172.22) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 64.9,
    y1: 199.31,
    x2: 77.11,
    y2: 234.11,
    gradientTransform: "translate(155.28 12.37) rotate(172.22) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 35.8,
    y1: 269.12,
    x2: 75.73,
    y2: 338.66,
    gradientTransform: "translate(198.53) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d9efc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 15.32,
    y1: 280.65,
    x2: 153.89,
    y2: 323.55,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 105.14,
    y1: 256.47,
    x2: 105.14,
    y2: 329.72,
    gradientTransform: "translate(198.53) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 211.61,
    y1: 257.76,
    x2: 164.55,
    y2: 246.27,
    gradientTransform: "translate(.44 -.05)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 212.46,
    y1: 248.84,
    x2: 166.8,
    y2: 237.7,
    gradientTransform: "translate(-29.07 23.01) rotate(-7.16)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 211.27,
    y1: 253.72,
    x2: 165.61,
    y2: 242.57,
    gradientTransform: "translate(-29.07 23.01) rotate(-7.16)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 212.35,
    y1: 249.3,
    x2: 166.69,
    y2: 238.16,
    gradientTransform: "translate(-29.07 23.01) rotate(-7.16)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 210.8,
    y1: 255.63,
    x2: 165.15,
    y2: 244.49,
    gradientTransform: "translate(-29.07 23.01) rotate(-7.16)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 179.14,
    y1: 245.87,
    x2: 176.2,
    y2: 312.22,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 450.53,
    y1: 226.42,
    x2: 291.82,
    y2: 156.65,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 451.78,
    y1: 208.19,
    x2: 301.46,
    y2: 142.11,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 448.12,
    y1: 216.04,
    x2: 298.08,
    y2: 150.09,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 452.29,
    y1: 206.86,
    x2: 302.15,
    y2: 140.86,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 447.43,
    y1: 217.8,
    x2: 297.28,
    y2: 151.8,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 193.33,
    y1: 150.59,
    x2: 268.07,
    y2: 219.47,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 132.21,
    y1: 286.27,
    x2: -37.9,
    y2: 136.45,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 737.72,
    y1: 407.13,
    x2: 678.74,
    y2: 359.32,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 748.08,
    y1: 394.35,
    x2: 689.1,
    y2: 346.54,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 752.99,
    y1: 388.29,
    x2: 694.01,
    y2: 340.48,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 589.55,
    y1: 220.62,
    x2: 589.55,
    y2: 312.92,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 598.59,
    y1: 215.37,
    x2: 598.59,
    y2: 285.15,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.85,11.76C179.39,11.76,26.61,164.53,26.61,352.99c0,55.43,13.22,107.78,36.68,154.05H672.4c23.46-46.27,36.68-98.62,36.68-154.05,0-188.45-152.78-341.23-341.23-341.23Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.36,
    cy: 39.19,
    r: 25.61,
    transform: "translate(12.82 109.32) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.6,
    cy: 418.39,
    r: 15.01,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.01,
    cy: 70.11,
    r: 7.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.23,
    cy: 7.27,
    r: 7.27,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 691.78,
    cy: 244.97,
    r: 24.57,
    transform: "translate(13.5 525.17) rotate(-41.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94,343.46c0,2.92-2.37,5.29-5.29,5.29s-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,414.01c0,2.92-2.37,5.29-5.29,5.29s-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.14,
    cy: 440.71,
    r: 47.99,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.12,436.12c.19-6.09-.58-11.81-1.84-16.98-1.01-4.17-1.31-8.46-.87-12.73,.21-2.11,.27-4.65,0-7.59-.93-9.6-11.3-31.21-29.25-34.27,0,0,3.11,11.2,5.92,19.78,3.62,11.05,7.52,17.94,13.65,23.97,6.19,6.1,10.21,14.09,10.68,22.77,.09,1.63,.11,3.29,.06,4.99l1.66,.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,419.15c-.21-4.15,.17-8.33,1.34-12.31,1.52-5.19,2.82-12.93,1.02-21.51-3.67-17.5-24.09-34.77-24.09-34.77,0,0,3.37,25.61,7.17,36.76,2.02,5.92,5.39,12.55,8.24,17.66,2.9,5.21,4.56,11.01,4.78,16.96,.6,16.29-1,27.89-1.03,28.09l1.64,.24c.03-.22,1.83-13.24,.92-31.12Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.84,336.59s-18.76,12.36-23.69,32.05c-1.52,6.06-1.11,11.35-.17,15.37,1.35,5.82,1.29,11.88,.22,17.76-4.79,26.42-2.31,48.97-2.27,49.26l1.65-.19c-.03-.27-2.28-20.67,1.66-45.29,1.15-7.19,4.19-13.98,8.85-19.57,3.03-3.62,6.57-9.18,9.6-17.48,5.52-15.11,4.15-31.91,4.15-31.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,396.73c-2.18,8.02-1.52,14.55-.41,18.93,.94,3.68,1.12,7.51,.49,11.26-3.08,18.31-2.37,35.74-2.36,35.99l1.66-.07c-.01-.24-.67-16.28,2.01-33.63,.73-4.74,2.74-9.18,5.82-12.84,2.9-3.44,6.21-8.38,8.71-14.04,6.82-15.39,9.28-34.79,9.28-34.79,0,0-20.52,11.94-25.2,29.19Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.2,428.03h-46.87s1.43,69.93,15.93,78.5h15s0,0,0,0c14.5-8.58,15.93-78.5,15.93-78.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M640.54,289.8h13.31c4.06,0,7.35,3.29,7.35,7.35v210.03",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,337.71h13.31c4.06,0,7.35,3.29,7.35,7.35v162.13",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,385.61h13.31c4.06,0,7.35,3.29,7.35,7.35v114.22",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,433.51h13.31c4.06,0,7.35,3.29,7.35,7.35v66.32",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,481.41h13.31c4.06,0,7.35,3.29,7.35,7.35v18.42",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.03,
    y1: 349.2,
    x2: 344.03,
    y2: 507.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 343.13,
    cy: 75.75,
    r: 22.91,
    transform: "translate(191.12 392.56) rotate(-76.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,72.48c0,4.74-3.38,8.58-7.54,8.58s-7.54-3.84-7.54-8.58,3.38-8.58,7.54-8.58,7.54,3.84,7.54,8.58Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,91.31c-4.18,4.52-10.17,7.35-16.81,7.35s-12.63-2.83-16.81-7.35c.82-1.06,1.75-2.03,2.76-2.9,3.06-2.63,6.9-4.38,11.09-4.89,1.97-.24,3.96-.24,5.93,0,5.58,.67,10.52,3.54,13.84,7.79Z",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 606.99,
    cy: 207.33,
    r: 11.45,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.76,205.69c0,2.37-1.69,4.29-3.77,4.29s-3.77-1.92-3.77-4.29,1.69-4.29,3.77-4.29,3.77,1.92,3.77,4.29Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.4,215.11c-2.09,2.26-5.08,3.67-8.4,3.67s-6.31-1.42-8.4-3.67c.41-.53,.87-1.01,1.38-1.45,1.53-1.32,3.45-2.19,5.54-2.44,.98-.12,1.98-.12,2.96,0,2.79,.33,5.26,1.77,6.92,3.9Z",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 55.02,
    cy: 286.79,
    r: 15.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.19,284.55c0,3.25-2.31,5.88-5.17,5.88s-5.17-2.63-5.17-5.88,2.31-5.88,5.17-5.88,5.17,2.63,5.17,5.88Z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.55,297.46c-2.86,3.1-6.97,5.04-11.52,5.04s-8.66-1.94-11.52-5.04c.56-.73,1.2-1.39,1.89-1.99,2.1-1.81,4.73-3.01,7.6-3.35,1.35-.16,2.72-.16,4.06,0,3.82,.46,7.21,2.43,9.49,5.34Z",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.28,84.11c0,3.64-2.95,6.6-6.6,6.6s-6.6-2.95-6.6-6.6,2.95-6.6,6.6-6.6,6.6,2.95,6.6,6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.75,79.6c-.32,0-.65-.09-.94-.27-.82-.52-1.07-1.61-.55-2.44,2.49-3.94,6.76-6.29,11.42-6.29s8.93,2.35,11.43,6.29c.52,.82,.28,1.92-.55,2.44-.82,.52-1.92,.28-2.44-.55-1.85-2.91-5-4.65-8.44-4.65s-6.59,1.74-8.44,4.65c-.34,.53-.91,.82-1.49,.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,75.08c-.39,0-.78-.13-1.11-.39-.76-.61-.88-1.72-.27-2.48,3.62-4.49,9-7.06,14.76-7.06s11.14,2.57,14.77,7.06c.61,.76,.49,1.87-.26,2.48-.76,.61-1.87,.5-2.48-.26-2.95-3.65-7.33-5.75-12.02-5.75s-9.07,2.1-12.01,5.75c-.35,.43-.86,.66-1.38,.66Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46,70.67c-.48,0-.96-.2-1.31-.58-3.95-4.36-9.59-6.86-15.47-6.86s-11.51,2.5-15.47,6.86c-.66,.72-1.77,.78-2.5,.12-.72-.66-.78-1.77-.12-2.5,4.62-5.09,11.21-8.02,18.08-8.02s13.47,2.92,18.09,8.02c.66,.72,.6,1.84-.12,2.5-.34,.31-.76,.46-1.19,.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,66.29c-.46,0-.92-.18-1.27-.53-5-5.14-11.7-7.97-18.87-7.97s-13.87,2.83-18.87,7.97c-.68,.7-1.8,.71-2.5,.03-.7-.68-.71-1.8-.03-2.5,5.67-5.83,13.27-9.04,21.4-9.04s15.73,3.21,21.4,9.04c.68,.7,.67,1.82-.03,2.5-.34,.33-.79,.5-1.23,.5Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.66,
    y: 458.91,
    width: 214.68,
    height: 42.53,
    rx: 8.84,
    ry: 8.84,
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 468.37,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.8,
    y: 468.37,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.44,
    y: 468.37,
    width: 96.89,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,480.21c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.11,480.21c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.67,
    y: 477.54,
    width: 15.18,
    height: 5.28,
    rx: 0.85,
    ry: 0.85,
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 439.67,
    y: 501.44,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.08,
    y: 501.44,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.34,474.7h3.67c.84,0,1.53,.69,1.53,1.53v7.89c0,.84-.69,1.53-1.53,1.53h-3.67v-10.95h0Z",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.66,
    y: 411.32,
    width: 214.68,
    height: 42.53,
    rx: 8.84,
    ry: 8.84,
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 420.78,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.8,
    y: 420.78,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.44,
    y: 420.78,
    width: 96.89,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,432.62c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.11,432.62c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.67,
    y: 429.95,
    width: 15.18,
    height: 5.28,
    rx: 0.85,
    ry: 0.85,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 439.67,
    y: 453.85,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.08,
    y: 453.85,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.34,427.11h3.67c.84,0,1.53,.69,1.53,1.53v7.89c0,.84-.69,1.53-1.53,1.53h-3.67v-10.95h0Z",
    fill: "url(#linear-gradient-22)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.66,
    y: 363.72,
    width: 214.68,
    height: 42.53,
    rx: 8.84,
    ry: 8.84,
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 373.19,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.8,
    y: 373.19,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.44,
    y: 373.19,
    width: 96.89,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,385.03c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.11,385.03c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.67,
    y: 382.35,
    width: 15.18,
    height: 5.28,
    rx: 0.85,
    ry: 0.85,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 439.67,
    y: 406.26,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.08,
    y: 406.26,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.34,379.51h3.67c.84,0,1.53,.69,1.53,1.53v7.89c0,.84-.69,1.53-1.53,1.53h-3.67v-10.95h0Z",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.66,
    y: 316.13,
    width: 214.68,
    height: 42.53,
    rx: 8.84,
    ry: 8.84,
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 325.59,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.8,
    y: 325.59,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.44,
    y: 325.59,
    width: 96.89,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,337.43c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.11,337.43c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.67,
    y: 334.76,
    width: 15.18,
    height: 5.28,
    rx: 0.85,
    ry: 0.85,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 439.67,
    y: 358.66,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.08,
    y: 358.66,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.34,331.92h3.67c.84,0,1.53,.69,1.53,1.53v7.89c0,.84-.69,1.53-1.53,1.53h-3.67v-10.95h0Z",
    fill: "url(#linear-gradient-33)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.66,
    y: 268.54,
    width: 214.68,
    height: 42.53,
    rx: 8.84,
    ry: 8.84,
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 278,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.8,
    y: 278,
    width: 17.02,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.44,
    y: 278,
    width: 96.89,
    height: 23.61,
    rx: 1.29,
    ry: 1.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,289.84c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.11,289.84c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07,2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07Z",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.67,
    y: 287.17,
    width: 15.18,
    height: 5.28,
    rx: 0.85,
    ry: 0.85,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 439.67,
    y: 311.07,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.08,
    y: 311.07,
    width: 15.18,
    height: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.34,284.33h3.67c.84,0,1.53,.69,1.53,1.53v7.89c0,.84-.69,1.53-1.53,1.53h-3.67v-10.95h0Z",
    fill: "url(#linear-gradient-36)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.3,353.16s1.26,2.65,2.05,4.73c.8,2.08-.22,5.83-.22,5.83h-1.64s-6.5,4.84-9.68,6.8c-3.18,1.96-4.5,2.65-6.18,2.66-1.26,.01-4.41-.95-4.1-2.91,.31-1.96,10.5-15.63,10.5-15.63,0,0,7.01,.13,9.28-1.48Z",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.2,304.67s1.52,1.76,3.16,4.19c1.63,2.43,1.8,7.27,1.8,7.27l-25.02,11.89s-4.32-2.76-.45-7.37c5.08-6.04,10.07-12.06,10.07-12.06,0,0,6.16-.61,10.44-3.91Z",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.41,300.71l2.35,7.87s6.37,.39,10.44-3.91l-1.56-6.87",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.53,240.12s9.45,1.26,14.82,.65c6.22-.71,.45-6.63,.45-6.63l-14.61,3.52-.67,2.46Z",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.96,248.65l-1.69,19.89h-19.87s-7.76-2.01-17.18-5.74c-3.32-1.31-6.85-2.84-10.31-4.56,1.25,2.67,1.77,5.25,2.48,10.78,2.33,18.12,4.29,31.35,4.29,31.35-6.03,4.02-12.08,3.62-12.08,3.62,0,0-14.77-40.11-17.05-54.17-1.25-7.72,4.12-16.19,21.19-14.02,6.07,.78,21.76,4.83,27.47,6.19,13.65,3.26,22.75,6.65,22.75,6.65Z",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.63,268.54h-13.23s-7.76-2.01-17.18-5.74c0,0,12.53,3.67,25.08,3.75,3.57,.02,5.01,.26,5.33,1.99Z",
    fill: "url(#linear-gradient-42)",
    "mix-blend-mode": "multiply",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.52,347.38l1.5,7.27s7.02,1.28,9.28-1.48l-.44-5.12",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5,245.79s-18.11,5.11-27.1,.3c0,0-27.84,34.07-28.93,46.91-.28,3.31,4.23,21.25,7.71,36.53,2.85,12.49,4.77,23.12,4.77,23.12,0,0,6.62,.11,10.64-1.45,0,0-1.03-44.28-4.5-55.29,8.52-6.06,21.92-15.32,29.79-24.85,1.3-1.58,3.21-2.53,5.26-2.53h0s6.79-8.53,2.36-22.75Z",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.55,213.46c-.96-.23-1.88-.48-2.76-.74-9.05-2.66-11.55-5.83-11.55-5.83,5.68-15.93,9.27-19.5,11.93-22.44,4.89-5.4,1.2,11.86,.63,12.16l1.76,16.85Z",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.57 197.69 447.49 207.33 452.52 206.07 449.57 197.69",
    fill: "url(#linear-gradient-46)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.86,244.25c.31,2.57,1.84,3.52,1.82,6.47,0,.71-2.44,3.75-8.64,4.85,0,0-13.19,5.92-25.96-4.68-6.14-5.1-13.01-8.22-13.01-8.22-.29-.19-.24-.7,.1-1.19,.27-.39,1.84-2.69,1.87-2.88,2.48-13.35,.39-14.68,.24-24.89,0-.25-.01-.51-.01-.76-.27-15.75-1.86-23.63-1.12-28.49,3.65-4.08,13.72-7.28,14.37-7.42,.03-.01,10.6-.08,12.91,0,5.28,1.36,14.62,4.16,19.27,12.08-.25,6.33,.15,14.01-.61,23.87-.13,1.49-2.56,20.29-1.23,31.27Z",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.94,152.79s-.8,5.49,1.76,6.49l1.01-6.07",
    fill: "#18213b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.27,184.84c-6.19-.74-3.41-7.05-2.75-7.88h0s1.03-6.71,1.11-7.03l10.5-4.58s.24,11.47,1.3,11.62c1.59,.75-.54,9.02-10.17,7.87Z",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.49,169.17s-2.28,5-7.68,5.99l.83-5.22,6.85-.77Z",
    fill: "url(#linear-gradient-49)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.19,152.53s-2.38,18.08,5.6,21.05c0,0,7.95,.75,12.58-5.48,1.33-1.79,3.02-2.2,3.57-4.36,.89-3.52,2.16-10.01,.55-13.92-2.29-5.57-22.08-10.85-22.29,2.71Z",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.52,139.83s1.86-4.3,7.58-2.26c4.01,1.43,6.05,4.41,6.05,4.41,0,0,1.6-1.29,3.07,.69,.96,1.3,.34,4.06,.34,4.06,9.52,1.74-.09,21.96-.21,22.61l-1.02,.6c-.27-2.96-.18-5.66-.35-7.73-.05-.62-1.04-.99-1.27-1.43-1.87,.31-3.71,.29-4.77-.62-1.86-1.59-2.24-4.19-2.43-5.95-1.76,.6-16.29,2.89-15.58-5.4,0,0-.65-1.28-.87-2.57-1.71-10.29,9.47-6.41,9.47-6.41Z",
    fill: "#18213b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.85,164.73c3.6,1.38,4.72-7.48,1.31-7.87-2.59-.3-2.7,3.32-2.7,3.32,0,0-.66,3.77,1.39,4.56Z",
    fill: "url(#linear-gradient-51)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "480.63 201.21 484.77 214.87 493.15 216.04 480.63 201.21",
    fill: "url(#linear-gradient-52)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.52,217.19c-3.43-10.35-9.55-22.65-9.55-22.65l-14.01,8.04s5.35,10.68,8.9,18.15c-3.42,.84-12.26,3.05-19.03,5.23-8.57,2.78-16.55,3.54-16.55,3.54,.38,2.64,.37,5.05,.37,5.05,8.37,.46,24.14,.58,35.3-.17,4.6-.3,8.53-.75,10.61-1.46,3.27-1.13,5.5-2.01,5.65-5.43,.22-5.01-1.61-10.17-1.68-10.29Z",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.71,238.6h-19.41v-1.9h19.41c.52,0,.95,.43,.95,.95h0c0,.52-.43,.95-.95,.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.21,238.6h-46.38c-.58,0-1.09-.39-1.25-.95l-9.94-35.8c-.22-.79,.38-1.58,1.2-1.58h44.77c1.09,0,2.06,.73,2.35,1.79l9.91,35.67c.12,.44-.21,.87-.66,.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.45,238.6h-46.38c-.58,0-1.09-.39-1.25-.95l-9.94-35.8c-.22-.79,.38-1.58,1.2-1.58h44.77c1.09,0,2.06,.73,2.35,1.79l9.91,35.67c.12,.44-.21,.87-.66,.87Z",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.52,238.6s.8,1.8,4.44,2.16l-.25-2.16h-4.19Z",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.36,232.51c.08-.34,.89-.71,1.55-.49-.28-.78-.5-1.45-.49-1.54,.07-.95,.99-.83,1.52-.53,.61,.34,1.31,1.91,1.5,2.08-.24-.5-.49-1.09-.47-1.15,.13-.56,1.38-1.03,2.09-.38,.36,.33,1.45,2.14,1.72,2.62-.08-.31-.12-.52-.11-.57,.13-.56,1.2-.76,1.91-.11,1.04,.95,2.53,4.43,2.53,4.43h0c.69,1.54,1.32,1.74,1.52,1.74h3.82s-.3,1.59-2.09,2.19c-1.78,.59-4.56,.97-8.02,.87-1.71-.04-3.76-.64-4.81-2.23-.36-.55-1.1-3.3-1.36-4.33h0c-.16-.53-.81-2.54-.8-2.59Z",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.7,189.12s3.09,3.87,8.62,17.29c0,0-8.33,4.89-18.49,6.9,0,0-2.13-4.31-7.14-16.91",
    fill: "url(#linear-gradient-57)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.57,
    y: 320.66,
    width: 30.34,
    height: 186.71,
    transform: "translate(629.47 828.02) rotate(180)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.86,
    y: 320.66,
    width: 28.01,
    height: 186.71,
    transform: "translate(623.74 828.02) rotate(180)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.86,
    y: 350.66,
    width: 28.01,
    height: 6.62,
    fill: "url(#linear-gradient-60)",
    "mix-blend-mode": "multiply",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.81,347.48l5.43-.65,14.51-91.48c.14-.87,.89-1.51,1.77-1.51h100.34l.99-3.14,3.98,2.52s.09,.05,.13,.08h.01s0,0,0,0c.49,.39,.76,1.01,.66,1.68l-14.93,94.14c-.14,.87-.89,1.51-1.77,1.51h-105.68c-.47,0-.88-.18-1.2-.47h0s-4.24-2.71-4.24-2.71Z",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.99,347.93h105.68c.88,0,1.63-.64,1.77-1.51l14.93-94.14c.17-1.09-.67-2.07-1.77-2.07h-105.68c-.88,0-1.63,.64-1.77,1.51l-14.93,94.14c-.17,1.09,.67,2.08,1.77,2.08Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.94,343.46h97c.56,0,1.04-.41,1.13-.96l13.72-86.51c.11-.69-.42-1.32-1.13-1.32h-97c-.56,0-1.04,.41-1.13,.96l-13.72,86.51c-.11,.69,.42,1.32,1.13,1.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,302.69h32.24c.71,0,1.31-.52,1.42-1.22l4.53-28.55c.14-.88-.54-1.67-1.42-1.67h-32.24c-.71,0-1.31,.52-1.42,1.22l-4.53,28.55c-.14,.88,.54,1.67,1.42,1.67Z",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.66,298.81h-2.23c-.33,0-.55-.26-.5-.59l2.66-16.77c.05-.33,.36-.59,.68-.59h2.23c.33,0,.55,.26,.5,.59l-2.66,16.77c-.05,.33-.36,.59-.68,.59Z",
    fill: "#ebf5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.41,298.81h-2.23c-.33,0-.55-.26-.5-.59l2.11-13.3c.05-.33,.36-.59,.68-.59h2.23c.33,0,.55,.26,.5,.59l-2.11,13.3c-.05,.33-.36,.59-.68,.59Z",
    fill: "#ebf5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,298.81h-2.23c-.33,0-.55-.26-.5-.59l2.51-15.78c.05-.33,.36-.59,.68-.59h2.23c.33,0,.55,.26,.5,.59l-2.51,15.78c-.05,.33-.36,.59-.68,.59Z",
    fill: "#ebf5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9,298.81h-2.23c-.33,0-.55-.26-.5-.59l3.75-23.59c.05-.33,.36-.59,.68-.59h2.23c.33,0,.55,.26,.5,.59l-3.75,23.59c-.05,.33-.36,.59-.68,.59Z",
    fill: "#ebf5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.65,298.81h-2.23c-.33,0-.55-.26-.5-.59l2.97-18.69c.05-.33,.36-.59,.68-.59h2.23c.33,0,.55,.26,.5,.59l-2.97,18.69c-.05,.33-.36,.59-.68,.59Z",
    fill: "#ebf5fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.44,322.83h17.7c.39,0,.72-.28,.78-.67l2.49-15.67c.08-.48-.3-.92-.78-.92h-17.7c-.39,0-.72,.28-.78,.67l-2.49,15.67c-.08,.48,.3,.92,.78,.92Z",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.28,334.79h39.29c.53,0,.98-.38,1.06-.91l3.38-21.33c.1-.65-.4-1.25-1.06-1.25h-39.29c-.53,0-.98,.39-1.06,.91l-3.38,21.33c-.1,.65,.4,1.25,1.06,1.25Z",
    fill: "url(#linear-gradient-65)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,320.46l-1.43,9.01h34.56l1.77-11.14s-2.16-1.14-5.06,.45c-2.28,1.25-5.58,4.86-7.86,4.6-2.28-.26-3.69-6.08-6.8-6.04-3.1,.04-5.63,6.43-8.12,6.49-2.49,.07-5.44-3.44-7.06-3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.42,279.01h19.1c.26,0,.48-.19,.52-.44l1.64-10.36c.05-.32-.2-.61-.52-.61h-19.1c-.26,0-.48,.19-.52,.44l-1.64,10.36c-.05,.32,.2,.61,.52,.61Z",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.28,282.68h13.32c.39,0,.76-.32,.82-.71h0c.06-.39-.2-.71-.6-.71h-13.32c-.39,0-.76,.32-.82,.71h0c-.06,.39,.2,.71,.6,.71Z",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,285.34h13.31c.39,0,.76-.32,.82-.71h0c.06-.39-.21-.71-.6-.71h-13.31c-.39,0-.76,.32-.82,.71h0c-.06,.39,.2,.71,.6,.71Z",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,287.99h13.31c.39,0,.76-.32,.82-.71h0c.06-.39-.2-.71-.6-.71h-13.31c-.39,0-.76,.32-.82,.71h0c-.06,.39,.21,.71,.6,.71Z",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.38,290.65h5.95c.39,0,.76-.32,.82-.71h0c.06-.39-.2-.71-.6-.71h-5.95c-.39,0-.76,.32-.82,.71h0c-.06,.39,.2,.71,.6,.71Z",
    fill: "url(#linear-gradient-70)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.88,321.85h18.7c.55,0,1.07-.45,1.15-1h0c.09-.55-.29-.99-.84-.99h-18.7c-.55,0-1.07,.45-1.15,.99h0c-.09,.55,.29,1,.84,1Z",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.29,325.58h18.7c.55,0,1.07-.45,1.15-.99h0c.09-.55-.29-.99-.84-.99h-18.7c-.55,0-1.07,.45-1.15,.99h0c-.09,.55,.29,.99,.84,.99Z",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.7,329.31h18.7c.55,0,1.07-.45,1.15-.99h0c.09-.55-.29-.99-.84-.99h-18.7c-.55,0-1.07,.45-1.15,.99h0c-.09,.55,.29,.99,.84,.99Z",
    fill: "url(#linear-gradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46,333.04h8.36c.55,0,1.07-.45,1.15-.99h0c.09-.55-.29-.99-.84-.99h-8.36c-.55,0-1.07,.45-1.15,.99h0c-.09,.55,.29,.99,.84,.99Z",
    fill: "url(#linear-gradient-74)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.33,268.95h12.79c.38,0,.73-.3,.79-.68h0c.06-.38-.2-.68-.57-.68h-12.79c-.38,0-.73,.3-.79,.68h0c-.06,.38,.2,.68,.57,.68Z",
    fill: "url(#linear-gradient-75)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.92,271.5h12.79c.38,0,.73-.3,.79-.68h0c.06-.38-.2-.68-.57-.68h-12.79c-.38,0-.73,.3-.79,.68h0c-.06,.38,.2,.68,.57,.68Z",
    fill: "url(#linear-gradient-76)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.59,274.05h5.71c.38,0,.73-.3,.79-.68h0c.06-.38-.2-.68-.57-.68h-5.71c-.38,0-.73,.3-.79,.68h0c-.06,.38,.2,.68,.57,.68Z",
    fill: "url(#linear-gradient-77)",
    opacity: 0.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M267.93,483.99l.81,12.26s7.31,2.55,12.01,0l1.26-12.59",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,506.53h-30.26c-.05-1.03-.23-3.75,.1-5.96,.37-2.54,1.19-4.32,1.19-4.32,5.7,1.22,12.01,0,12.01,0,0,0,9.79,2.95,13.67,5.17,2.95,1.69,3.42,4.06,3.29,5.11Z",
    fill: "url(#linear-gradient-79)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.25,479.06l-3.31,10.97s4.63,4.72,10.43,3.79l5.6-13.45",
    fill: "url(#linear-gradient-80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.43,506.51s-.25,.03-.28,.03h-11.93c-.21-.01-.4-.01-.58-.03-3.07-2.79-14.4-12.38-14.19-12.96,.19-.59,1.18-2.54,2.77-4.86,1.77-2.59,4.25-3.77,4.25-3.77,4.75,4.01,10.86,4.2,10.86,4.2,0,0,2.95,7.88,4.63,9.33,1.95,.27,6.63,2.87,4.47,8.06Z",
    fill: "url(#linear-gradient-81)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282,491.2c-9.77,2.64-14.61-.54-14.61-.54,0,0-2.83-44.86-3.02-52.99-.2-8.83,.46-16.41,.46-16.41-4.12-7.55-9.53-29.39-9.53-29.39,0,0-1.91,7.74-3.95,15.33h0c-1.33,5.01-2.73,9.95-3.71,12.57-2.77,7.54-31.91,67.36-31.91,67.36-11.95-1.13-13.85-4.91-13.85-4.91,0,0,7.82-26.46,13.95-43.83,6.12-17.38,10.06-25.38,10.06-25.38l4.66-46.18s-2.42-6.35-2.14-11.32c.31-5.75,4.22-15.09,4.22-15.09l40.92-2.06,4.51,8.09s8.65,62.75,9.26,72.29c.62,9.54-5.32,72.46-5.32,72.46Z",
    fill: "url(#linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.49,233.35c-.19,2.48-1.4,5.62-2.04,9.35-.46,2.69-1.44,6.28-2.89,9.22-1.45,2.94-3.07,5.15-4.82,5.54-3.55,.8-15.98-2.86-19.45-16.39-4.09-15.96,7.43-20.3,13.09-19.49,5.66,.81,16.75,3.27,16.1,11.76Z",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74,249.67s-1.72,5.41-2.23,12.25c0,0-10.82,1.8-16.67-1.37,0,0,6.07-12.36,6.7-23.14",
    fill: "#edcbad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.05,289.27s-4.35,15.14-3.77,20.85c.21,2.07,12.92,7.61,12.92,7.61l2.4-21.62-11.55-6.84Z",
    fill: "url(#linear-gradient-84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.03,299.81c-.28-.01-.56-.03-.83-.05-3.18-.2-5.83-.83-7.88-1.53-3.26-1.11-5-2.39-5-2.39,3.61-14.89,6.62-22.08,6.62-22.08l7.09,26.04Z",
    fill: "url(#linear-gradient-85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2,299.76c-3.18-.2-5.83-.83-7.88-1.53,.7-4.61,1.38-10.95,1.38-10.95l1.43,1.96,5.07,10.52Z",
    fill: "url(#linear-gradient-86)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.64,343.53c.23,1.86-.58,2.91-.58,2.91-16.7-4.73-32.83,19.88-51.95,4.28-.78-.64,5.54-11.69,8.83-30.57,1.06-6.11,1.27-13.7,1.43-21.15,.23-10.21-2.56-19.48-.46-25.05,2.75-7.28,11.89-12.22,15.92-12.95,0-.01,7-1.57,16.1,1.05,7.73,2.23,13.81,12.26,13.81,12.26,.28,4.8-1.68,13.19-3.42,22.48-1.13,5.99-2.17,12.37-2.45,18.39-.01,.32-.03,.66-.04,.99-.24,9.45,2.08,21.5,2.8,27.37Z",
    fill: "url(#linear-gradient-87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.33,296.77c-1.13,5.99-2.17,12.37-2.45,18.39-.01,.32-.03,.66-.04,.99l-.07,.19-8.08-27.47,4.05,.4,6.59,7.49Z",
    fill: "url(#linear-gradient-88)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.26,286.09s.74-2.3,1.05-3.61c.3-1.32,.48-2.75,.93-2.66s1.03,.88,1.26,1.89c.23,1,0,3.2,0,3.2l-3.24,1.18Z",
    fill: "url(#linear-gradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.58,281.09c-.28-.05-1.06,.39-1.9,.75-1.15,.5-2.37,.99-2.37,.99l-2.64,1.71c.49-.52,1.07-1.09,1.66-1.57,.91-.75,1.76-1.4,1.96-1.6,1.41-1.38,.44-2.25-.38-1.79-.81,.46-2.73,1.4-3.34,1.87-1.04,.8-3.45,3.26-3.65,3.47-.34,.36-3.07,6.13-3.66,6.92-.69,.91-3.03,2.27-3.03,2.27-7.19,3.02-21.73,8.88-21.73,8.88l-5.68-11.72-16.14,3.57s11.3,20.29,14.71,22.59c7.47,5.05,28.05-16.12,34.55-19.61,0,0,3.32-1.48,4.63-2.74,.77-.75,1.21-1.7,1.44-2.37h0s.64-1.35,.64-1.35c0,0,.15,1.91,.3,2.75,.15,.84,1.01,1.24,1.35,.92,.15-.14,.21-1.24,.34-2.41,.16-1.46,.36-3.06,.22-3.25-.26-.34-.98-1.29-.98-1.29,0,0,.12-.6-.16-.81-.24-.19-.84-.65-1.23-.77l2.2-1.78s.88-.49,2.16-1.32c1.29-.83,1.15-2.21,.71-2.29Z",
    fill: "url(#linear-gradient-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.93,279.08c-.82,8.2,7.92,22.88,7.92,22.88,0,0,8.97-1.58,16.65-8.63,0,0-5.81-14.83-8.76-19.04-3.17-4.52-14.99-3.37-15.81,4.79Z",
    fill: "url(#linear-gradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,231.85c1.07-2.87,.44-6.02-4.76-6.13-6.06-10.18-17.79-8.01-21.39-7.09-9.72,2.34-14.81,13.33-13.72,21.41,1.26,9.4,3.78,11,4.74,12.3,.95,1.28,8.83,3.24,12.78,1.33,1.3-.63,5.2-12.21,5.64-13.46,.1-.3,.2-.62,.43-.83,.37-.33,.92-.25,1.41-.23,.11,0,.21,0,.32,0-.07,1.19,.11,2.69,1.54,2.34,1.24-.3,2.13-1.46,2.68-2.47,6.85-1.25,9.65-5.36,10.32-7.17Z",
    fill: "#18213b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5,241.33s.02-4.69-3.39-4.06c-3.03,.56-3.66,9.26-.86,9.89,2.8,.63,4.47-2.26,4.24-5.83Z",
    fill: "url(#linear-gradient-92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25,229.5s-13.37,18.35-8.85,31.02c1.93,5.41,26.08,11.64,32.37,1.91-5.39-1.65-3.91-16.8-3.91-16.8l-19.61-16.13Z",
    fill: "#18213b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3,391.86s-1.91,7.74-3.95,15.33v-28.95l3.95,13.62Z",
    fill: "url(#linear-gradient-93)",
    "mix-blend-mode": "multiply",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.46,484.35l-.51,12.69s5.5,2.32,9.8,0l3.2-12.07",
    fill: "url(#linear-gradient-94)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.9,480.19l-3.17,15.09s6.1,3,10.87,.94l3.93-12.53",
    fill: "url(#linear-gradient-95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,506.7h26.78c.33,0,.59-.29,.52-.61-.25-1.1-1.83-2.85-4.86-4.43-3.15-1.63-10.9-4.63-10.9-4.63,0,0-5.5,.97-9.8,0,0,0-1.53,1.56-1.87,3.87-.35,2.32,.14,5.29,.14,5.8Z",
    fill: "url(#linear-gradient-96)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,276.73l19.47,28.46s2.02,8.25-7.41,7.21c-9.43-1.04-23.7-24.21-23.7-24.21",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.43,286.12s-5.28,8.47-13.95,13.46l-13.34-12.88-.38-29.4s7.59,3.09,15.29,12.18c3.05,3.59,6.25,7.63,12.37,16.64Z",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.98 277.43 155.08 286.62 146.95 285.06 150.98 277.43",
    fill: "url(#linear-gradient-99)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,332.54s-9.52,29.35-12.71,55.29c-3.19,25.94-1.99,19.92-3.04,26.58-.95,6.01-2.42,14.65-5.19,27.13-2.77,12.48-6.96,47.02-6.96,47.02,0,0,5.78,2.5,12.15,1.61,0,0,15.4-39.6,17.57-50.74,2.18-11.23,2.84-23.48,2.84-23.48,0,0,11.69-23.47,16.26-40.39l2.46-.69-.47,46.23s-7.47,16.92-8.69,30.72c-1.22,13.83-1.92,38.76-1.92,38.76,0,0,8.79,2.67,11.78,.6,0,0,14.91-56.92,18.51-71.2,3.6-14.28,9.34-46.98,9.72-53.51,1.34-23.01-1.95-32.84-1.95-32.84l-50.35-1.12Z",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.76,495.72s-5.87,.75-10.95-.81l-.68,2.12s-5.01,1.71-6.92,3.78c-2.9,3.15-1.62,5.9-1.62,5.9h21.68s1.15-5.34-1.52-10.98Z",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,332.11c-.31,2.68-1.74,3.28-1.74,3.28,0,0-10.51,5.48-49.85-.54,0,0-1.41-.27-.87-2.87,1.41-6.76,2.27-14.88,1.88-20.78-.13-2.1-.44-3.91-.92-5.28-1.46-4.13-3.61-9.92-5.4-15.92-2.18-7.25-3.85-14.81-3.19-20.12,1.35-10.91,20.41-15.51,20.41-15.51l16.33-.15s14.38,1.46,21.1,11.59c5.21,7.87,2.72,34.88,1.49,53.07-.36,5.38,1.13,10.13,.78,13.22Z",
    fill: "url(#linear-gradient-102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.85,288.07l-2.94,23.14h-1.98c-.13-2.1-.44-3.91-.92-5.28-1.46-4.13-3.61-9.92-5.4-15.92l11.25-1.93Z",
    fill: "url(#linear-gradient-103)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.09,217.66s2.68,10.17-1.25,12.08c-3.2,1.56-3.48-2.99-3.48-2.99l-.76-4.96",
    fill: "#18213b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,254.37s2.67,6.9,12.8,5.92c8.81-.85,3.54-6.06,3.54-6.06,0,0-.46-1.39-1.02-3.23-.54-1.8-1.19-4.02-1.59-5.77l-3.53-2.89-7.48-6.12s.97,13.3-2.73,18.15Z",
    fill: "url(#linear-gradient-104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,242.41s3.05,6.51,9.69,8.59c-.54-1.8-1.19-4.02-1.59-5.77l-3.53-2.89-4.57,.07Z",
    fill: "url(#linear-gradient-105)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,223.58s4.23,20.4-1.68,23.6c0,0-6.71,2.51-13.72-3.18-2.02-1.64-3.63-3.72-4.87-6-2.02-3.71-5.31-10.67-4.61-15.54,.98-6.94,20.75-14.11,24.89,1.12Z",
    fill: "url(#linear-gradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.2,232.84s-1.21-3.75-3.83-2.65c-3.45,1.45,.35,10.29,3.76,7.83",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.38,216.79c4.41-8.76,12.57-4.58,21.7-5.46,3.1-2.98,6.35-3.13,8.01-2.28,2.28,1.17,2.16,5.7,1.96,7.62-1.23,12.01-14.48,11.1-18.34,10.56-.11,.91-.35,1.77-.87,2.51-.51,.73-1.38,1.23-2.43,1.56-.47-.67-1.15-1.3-2.07-1.32-.3,0-.63,.05-.97,.2-.72,.3-1.12,.93-1.27,1.7-.33,1.53,.58,3.87,1.66,5.28,.05,2.62-.17,4.93-.18,6.51,0,0-2.11-3.5-3.45-5.06-.74-.85-2.81-3.65-4.07-7.32t-.01-.01c-.79-1.33-5.91-10.32,.33-14.48Z",
    fill: "#18213b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.57,325.23l-28.93-.81c-1.4-.04-2.35-1.42-1.91-2.74l13.44-39.72c.51-1.5,1.94-2.5,3.52-2.45l28.93,.81c1.4,.04,2.35,1.42,1.91,2.74l-13.44,39.72c-.51,1.5-1.94,2.5-3.52,2.45Z",
    fill: "url(#linear-gradient-108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,303.35c-.24-.64-1.53-.38-1.92-.24-.37,.14-.83,.34-1.52,.64-.16,.07-.34,.15-.52,.22,1.06-.62,1.79-1.06,1.54-1.71-.24-.64-1.53-.38-1.92-.24-.37,.14-.83,.34-1.52,.64-.98,.42-2.44,1.06-3.31,1.44-1.55,.24-3.43,.76-3.42,.68,.08-.56,.44-1.26,.56-1.89,.27-.59,1.2-2.84,.61-3.58-.67-.84-1.14-.5-1.66,.57-.52,1.07-2.05,2.61-2.59,3.23-.55,.61-.62,1.24-1.34,2.1-.88,1.05-2.19,1.51-2.95,1.71-1.4,.3-13.92,.78-22.63,1.03,2.51-8.52,4.18-21.3,4.18-21.3l-16.37-6.2s-6.11,36.73-4.15,40.09c1.42,2.41,5.15,3.57,8.95,3.15,5.06-.55,15.86-4.58,31.83-9.1,2.51-.34,4.17-.63,7.4-1.04,1.01-.13,2.04-.39,2.86-.72h0s.03,0,.07-.03c.07-.03,.14-.06,.21-.09,.56-.24,1.85-.84,2.97-1.53,1.46-.91,3.21-2.05,2.9-2.86-.14-.38-.67-.44-1.15-.4,1.32-.82,2.45-1.53,2.17-2.27-.12-.31-.48-.41-.86-.41,1.09-.68,1.81-1.21,1.56-1.89Z",
    fill: "url(#linear-gradient-109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,267.69c1.99-3.72,9.82-7.98,9.82-7.98l7.87,18.54c.09,6.58-4,23.75-4,23.75-2.32,.21-7.43-.02-11.38-.63-4.74-.75-9.79-2.35-9.79-2.35,0,0,2.67-22.32,7.48-31.34Z",
    fill: "url(#linear-gradient-110)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.25,
    y: 234.76,
    width: 61.51,
    height: 20.13,
    rx: 4.74,
    ry: 4.74,
    transform: "translate(-29.01 25.7) rotate(-7.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,242.1h5.71c1.38,0,2.5,1.12,2.5,2.5v5.71c0,1.38-1.12,2.5-2.5,2.5h-5.71c-1.38,0-2.5-1.12-2.5-2.5v-5.71c0-1.38,1.12-2.5,2.5-2.5Z",
    transform: "translate(-29.5 23.11) rotate(-7.16)",
    fill: "url(#linear-gradient-111)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.4,239.84l-35.93,4.51c-.29,.04-.55-.17-.59-.46v-.03c-.04-.29,.17-.55,.45-.59l35.93-4.51c.29-.04,.55,.17,.59,.46v.03c.04,.29-.17,.55-.45,.59Z",
    fill: "url(#linear-gradient-112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,245.04l-14.89,1.87c-.29,.04-.55-.17-.59-.46v-.03c-.04-.29,.17-.55,.45-.59l14.89-1.87c.29-.04,.55,.17,.59,.46v.03c.04,.29-.17,.55-.45,.59Z",
    fill: "url(#linear-gradient-113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.72,242.4l-18.9,2.37c-.29,.04-.55-.17-.59-.46v-.03c-.04-.29,.17-.55,.45-.59l18.9-2.37c.29-.04,.55,.17,.59,.46v.03c.04,.29-.17,.55-.45,.59Z",
    fill: "url(#linear-gradient-114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,247.03l-19.42,2.44c-.29,.04-.55-.17-.59-.46v-.03c-.04-.29,.17-.55,.45-.59l19.42-2.44c.29-.04,.55,.17,.59,.46v.03c.04,.29-.17,.55-.45,.59Z",
    fill: "url(#linear-gradient-115)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.19,256.21c-.08-.04-.14-.06-.14-.06,0,0,.39-1.09,.73-2.32,.31-.61,1.14-1.92,1.14-2.67,0-2.31-1.77-.72-2.76,.33-2.54,2.16-4.36,4.11-4.36,6.24,0,4.06-.14,7.24-.14,7.25-3.38,9.69-10.24,29.39-10.24,29.39l12.2,15.44s2.49-4.16,3.37-23.78c.34-7.56,1.83-15.76,2.46-19.05,0-.01,3.02-3.55,4-6.06,.61-.89,1.17-1.69,1.45-2.06,.84-1.12,1.39-3.79,1.39-3.79l-9.11,1.14Z",
    fill: "url(#linear-gradient-116)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 329.9,
    y: 165.79,
    width: 80.39,
    height: 26.32,
    rx: 4.74,
    ry: 4.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.55,
    y: 171.96,
    width: 13.99,
    height: 13.99,
    rx: 2.5,
    ry: 2.5,
    fill: "url(#linear-gradient-117)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.23,176.28h-47.29c-.39,0-.71-.32-.71-.71h0c0-.39,.32-.71,.71-.71h47.29c.39,0,.71,.32,.71,.71h0c0,.39-.32,.71-.71,.71Z",
    fill: "url(#linear-gradient-118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.53,179.66h-19.58c-.39,0-.71-.32-.71-.71h0c0-.39,.32-.71,.71-.71h19.58c.39,0,.71,.32,.71,.71h0c0,.39-.32,.71-.71,.71Z",
    fill: "url(#linear-gradient-119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.23,179.66h-24.86c-.39,0-.71-.32-.71-.71h0c0-.39,.32-.71,.71-.71h24.86c.39,0,.71,.32,.71,.71h0c0,.39-.32,.71-.71,.71Z",
    fill: "url(#linear-gradient-120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.49,183.03h-25.55c-.39,0-.71-.32-.71-.71h0c0-.39,.32-.71,.71-.71h25.55c.39,0,.71,.32,.71,.71h0c0,.39-.32,.71-.71,.71Z",
    fill: "url(#linear-gradient-121)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.02,142.2h47.54c3.51,0,6.35,2.85,6.35,6.35v27.03c0,3.51-2.85,6.35-6.35,6.35h-47.54c-3.51,0-6.35-2.85-6.35-6.35v-27.03c0-3.51,2.85-6.35,6.35-6.35Z",
    fill: "url(#linear-gradient-122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.01,154.68l10.05,5.8c1.65,.95,1.65,3.34,0,4.29l-10.05,5.8c-1.65,.95-3.72-.24-3.72-2.15v-11.6c0-1.91,2.07-3.1,3.72-2.15Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 165.67,
    width: 85.35,
    height: 83.49,
    rx: 6.5,
    ry: 6.5,
    fill: "url(#linear-gradient-123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.51,197.48H18.33c-4.5,0-8.14-3.64-8.14-8.14h0c0-4.5,3.64-8.14,8.14-8.14H55.51c4.5,0,8.14,3.64,8.14,8.14h0c0,4.5-3.64,8.14-8.14,8.14Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.02,223.69H29.84c-4.5,0-8.14-3.64-8.14-8.14h0c0-4.5,3.64-8.14,8.14-8.14h37.18c4.5,0,8.14,3.64,8.14,8.14h0c0,4.5-3.64,8.14-8.14,8.14Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.87,186.22H18.85c-.54,0-.98-.44-.98-.98h0c0-.54,.44-.98,.98-.98H56.87c.54,0,.98,.44,.98,.98h0c0,.54-.44,.98-.98,.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,190.33H18.85c-.54,0-.98-.44-.98-.98h0c0-.54,.44-.98,.98-.98H56.87c.54,0,.98,.44,.98,.98h0c0,.54-.44,.98-.98,.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.88,194.44H18.85c-.54,0-.98-.44-.98-.98h0c0-.54,.44-.98,.98-.98h18.03c.54,0,.98,.44,.98,.98h0c0,.54-.44,.98-.98,.98Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.85,212.43h38.02c.54,0,.98-.44,.98-.98h0c0-.54-.44-.98-.98-.98H28.85c-.54,0-.98,.44-.98,.98h0c0,.54,.44,.98,.98,.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.18,216.54h23.68c.54,0,.98-.44,.98-.98h0c0-.54-.44-.98-.98-.98h-23.68c-.54,0-.98,.44-.98,.98h0c0,.54,.44,.98,.98,.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.85,216.54h10.14c.54,0,.98-.44,.98-.98h0c0-.54-.44-.98-.98-.98h-10.14c-.54,0-.98,.44-.98,.98h0c0,.54,.44,.98,.98,.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.84,220.64h18.03c.54,0,.98-.44,.98-.98h0c0-.54-.44-.98-.98-.98h-18.03c-.54,0-.98,.44-.98,.98h0c0,.54,.44,.98,.98,.98Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.99,234.55c0,1.05-.85,1.9-1.9,1.9s-1.9-.85-1.9-1.9,.85-1.9,1.9-1.9,1.9,.85,1.9,1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.67,234.55c0,1.05-.85,1.9-1.9,1.9s-1.9-.85-1.9-1.9,.85-1.9,1.9-1.9,1.9,.85,1.9,1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.35,234.55c0,1.05-.85,1.9-1.9,1.9s-1.9-.85-1.9-1.9,.85-1.9,1.9-1.9,1.9,.85,1.9,1.9Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.67,
    y: 328.32,
    width: 64.82,
    height: 60.5,
    rx: 5.35,
    ry: 5.35,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.7,332.55h48.75c1.94,0,3.51,1.57,3.51,3.51v45.03c0,1.94-1.57,3.51-3.51,3.51h-48.75c-1.94,0-3.51-1.57-3.51-3.51v-45.03c0-1.94,1.57-3.51,3.51-3.51Z",
    fill: "#ebf5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.85,384.6h-34.96c-1.99,0-3.69-1.24-4.36-3l15.3-22.79c1.6-2.36,5.09-2.36,6.68,0l4.88,7.25,12.47,18.55Z",
    fill: "url(#linear-gradient-124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.97,359.11v20.79c0,2.59-2.12,4.7-4.7,4.7h-36.34l12.46-18.55,13.64-20.29c1.43-2.13,4.55-2.13,5.98,0l8.97,13.34Z",
    fill: "url(#linear-gradient-125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.3,345.16c0,4.7-3.81,8.52-8.52,8.52s-8.52-3.81-8.52-8.52,3.81-8.52,8.52-8.52,8.52,3.81,8.52,8.52Z",
    fill: "url(#linear-gradient-126)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M635.21,239.68l-45.66-18.18-45.66,18.18s-2.23,64.33,45.66,80.98c47.9-16.65,45.66-80.98,45.66-80.98Z",
    fill: "url(#linear-gradient-127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,229.44l38.19,15.2c-.64,13.6-5.31,54.87-38.19,68.14-32.83-13.25-37.55-54.53-38.2-68.14l38.2-15.2m0-4.33l-42.32,16.84c.19,10.99,3.2,60.65,42.32,75.14,39.1-14.49,42.13-64.15,42.3-75.14l-42.3-16.84h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.95,263.51s20.3,13.52,27.53,32.4c0,0,19.48-49.67,45.74-66.47,0,0-25.47,5.03-48.03,46.8,0,0-9.94-11.73-25.24-12.73Z",
    fill: "url(#linear-gradient-128)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 19.98,
    y1: 507.18,
    x2: 716.33,
    y2: 507.18,
    fill: "none",
    stroke: "#232231",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 128.72,
    y1: 194.44,
    x2: 128.72,
    y2: 191.08,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72,183.03v-31.79c0-21.52,17.45-38.97,38.97-38.97H489.03c21.52,0,38.97,17.45,38.97,38.97v96.06",
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "0 0 6.71 8.05",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528,
    y1: 251.32,
    x2: 528,
    y2: 254.67,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.68
  })), /*#__PURE__*/React.createElement("line", {
    x1: 269.77,
    y1: 112.27,
    x2: 269.77,
    y2: 207.33,
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "0 0 6.7 8.04",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.19,
    y1: 112.27,
    x2: 432.19,
    y2: 194.54,
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "0 0 6.7 8.04",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.68
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginVector);
export default __webpack_public_path__ + "static/media/loginVector.5c33159ac01d5aab759d9e2fb22fa470.svg";
export { ForwardRef as ReactComponent };